
import React from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import * as bie from "react-bootstrap";
import CommanFfcaDocumnets from './CommanFfcaDocumnets';
export default function AfflFfcaDocuments() {


    return (
        <>

            <CommonFormHeading heading="Documents" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <bie.Row className="px-2 pt-3 mb-3">
                        <CommanFfcaDocumnets />

                    </bie.Row>
                </bie.Container>

            </bie.Container>

        </>
    )
}

